export class Base64HeaderCodes {
  public readonly JPEG: string[] = [
    'ffd8ffe0',
    'ffd8ffe1',
    'ffd8ffe2',
    'ffd8ffe3',
    'ffd8ffe8'
  ];
  public readonly PNG: string = '89504e47';
  public readonly PDF: string = '25504446';

  public readonly JPEG_TYPE: string = 'image/jpeg';
  public readonly PNG_TYPE: string = 'image/png';
  public readonly PDF_TYPE: string = 'application/pdf';
}
